export default {
  All: 'Include All Body Types',
  F: 'Front',
  C: 'Centre',
  R: 'Rear',
  FC: 'Front+Centre',
  RC: 'Rear+Centre'
}
